import z from "zod";
import { baseEntitySchema } from "./base";

export const ConfigDataSchema = z.object({
  promoCodesEnabled: z.boolean().default(false),
});

export type ConfigData = z.infer<typeof ConfigDataSchema>;
export const configSchema = baseEntitySchema.extend(ConfigDataSchema.shape);
export type Config = z.infer<typeof configSchema>;
